<!-- 组件说明 -->
<template>
  <div class="main">
    <Header
      :title="title"
    />
    <van-tabs
      v-model="active"
      sticky
      animated
      offset-top="45"
      color="#fff"
      title-inactive-color="#eee"
      title-active-color="#fff"
      :border="false"
    >
      <van-tab
        :title="v.txt"
        v-for="(v,i) in tabList"
        :key="i"
      >
        <van-collapse
          v-model="activeNames"
        >
          <van-collapse-item
            title="姓名"
            :value="data.name"
            :is-link="false"
            disabled
            class="mb0"
          />
          <!-- data.registerDate -->
          <van-collapse-item
            title="筛查日期"
            :value="data.registerDate"
            :is-link="false"
            disabled
          />

          <template
            v-for="(x, y) in reportList"
          >
            <van-collapse-item
              :key="y"
              :title="x.name"
              name="3"
              :is-link="false"
              disabled
              v-if="x.l || x.y || x.picUrl.length"
            >
              <div class="item_txt">
                <p v-if="x.l">
                  {{ x.l }}
                </p>
                <p v-if="x.r">
                  {{ x.r }}
                </p>
                <div
                  v-for="(vs, vc) in x.picUrl"
                  :key="vc"
                  class="img-wrap"
                >
                  <template v-if="x.picType < 9">
                    <div
                      class="img-label"
                      v-if="vs.position"
                    >
                      <!-- @click="showPopupFun(vs.id, vs.position)" -->
                      <!-- <van-icon :name="require('../assets/img/update.png')" /> -->
                      {{ vs.position === 1 ? '左侧乳房' : '右侧乳房' }}
                    </div>
                    <!-- <div
                      class="img-label"
                      v-else
                      @click="showPopupFun(vs.id)"
                    >
                      <van-icon :name="require('../assets/img/add.png')" />
                      添加标签
                    </div> -->
                  </template>
                  <van-image
                    :src="$imgUrl + vs.picUrl"
                    @click="seeImg($imgUrl + vs.picUrl)"
                  >
                    <template v-slot:error>
                      图片加载失败
                    </template>
                  </van-image>
                </div>
              </div>
            </van-collapse-item>
          </template>
          <router-link
            to="/bgDetails"
            v-if="data.isWatchReport === 1 && active === 0"
          >
            <van-collapse-item
              title="报告解读"
              disabled
            />
          </router-link>
          <!-- data.nextStep -->
          <router-link to="/doctorList">
            <van-collapse-item
              title="推荐医生"
              disabled
              right-icon="success"
              class="mb0"
            />
          </router-link>
          <div
            class="tj_doctor_list"
            @touch.stop
          >
            <div
              class="tj_doctor_item"
              v-for="(item, index) in data.recommendDocs"
              :key="index"
            >
              <van-image
                :src="$imgUrl + item.headicon"
                type="contain"
                :error-icon="require('../assets/img/default.png')"
              />
              <p>
                <span class="name">{{ item.name }}</span>
                <span class="ks">{{ item.department }}</span>
              </p>
              <p class="hospital">
                {{ item.hospital }}
              </p>
              <van-button @click="phone(item.phone)">
                咨询医生
              </van-button>
            </div>
          </div>
        </van-collapse>
      </van-tab>
    </van-tabs>
    <van-overlay
      :show="show"
      @click="show = false"
    >
      <div
        class="wrapper"
      >
        <div
          class="block"
          @click.stop
        >
          <p>{{ phoneNumber }}</p>
          <div class="footer">
            <span
              class="cancel"
              @click="show = false"
            >取消</span>
            <a :href="'tel:' + phoneNumber">
              <span
                class="confirm"
              > 拨打 </span>
            </a>
          </div>
        </div>
      </div>
    </van-overlay>
    <van-overlay
      :show="show1"
      lock-scrool
    >
      <van-loading
        color="#fff"
        size="1.5rem"
        text-size=".5rem"
        vertical
      >
        加载中...
      </van-loading>
    </van-overlay>
    <van-popup
      v-model="showPopup"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :default-index="defaultPicker"
        :columns="[{text: '左侧乳房', type: 1}, {text: '右侧乳房', type: 2}]"
        @cancel="showPopup = false"
        @confirm="updateLabel"
      />
    </van-popup>
  </div>
</template>

<script>
import { Picker, Popup, Loading, Tabs, Tab, Icon, Button, Image, Cell, Collapse, CollapseItem, Overlay, ImagePreview } from 'vant'
import Header from '../components/header'
import { formatPathologicalCervixResult } from '@/utils/pathologicalCervix'

export default {
  data () {
    return {
      active: 0,
      title: '筛查记录',
      phoneNumber: '',
      show: false,
      show1: false,
      tabList: [],
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
      data: '',
      showPopup: false,
      defaultPicker: '',
      imgId: ''
    }
  },
  components: {
    Header,
    [Tab.name]: Tab,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [ImagePreview.name]: ImagePreview
  },

  computed: {
    leftData () {
      if (this.data && this.data.resultPic) {
        const data = JSON.parse(this.data.resultPic)
        return JSON.parse(data.leftdata).BI_RADS
      } else {
        return ''
      }
    },
    rightData () {
      if (this.data && this.data.resultPic) {
        const data = JSON.parse(this.data.resultPic)
        return JSON.parse(data.rightdata).BI_RADS
      } else {
        return ''
      }
    },
    reportList () {
      if (this.data.isWatchReport === 1 && this.active === 0) {
        return this.data.reportList.filter(v => v.picType < 9)
      } else {
        return this.data.reportList.filter(v => v.picType > 8)
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    showPopupFun (id, num) {
      this.imgId = id
      this.defaultPicker = num - 1
      this.showPopup = true
    },
    updateLabel (data) {
      this.$api.personal.pictureEdit({
        id: this.imgId,
        position: data.type
      }).then(res => {
        this.showPopup = false
        this.getData()
      })
    },
    seeImg (url) {
      ImagePreview({
        images: [url],
        showIndex: false
      })
    },
    phone (phone) {
      this.phoneNumber = phone
      this.show = true
    },
    getData () {
      this.show1 = true
      this.$api.personal.getByPk({
        id: this.$route.params.id,
        type: 0
      }).then(async res => {
        const d = res.data
        let fertileCheck
        if (d.pathologicalCervix) {
          const { data: ins } = await this.$api.personal.getInstitutionById({
            id: d.institutionId
          })
          fertileCheck = ins.fertileCheck
        }
        this.tabList = []
        if (d.isWatchReport === 1) this.tabList.push({ txt: '乳腺筛查' })
        if (d.isWatchReportCervix === 1) this.tabList.push({ txt: '宫颈筛查' })
        // this.tabList.push({ txt: '乳腺筛查' }, { txt: '宫颈筛查' })

        // 数据分类
        const reportList = [
          // 乳腺
          // { picType: 0, name: '医生建议', picUrl: [] },
          { picType: 1, name: '临床检查', picUrl: [] },
          { picType: 2, name: '超声检查', picUrl: [] },
          // { picType: 3, name: 'aibus', picUrl: [] },
          { picType: 4, name: '钼靶检查', picUrl: [] },
          { picType: 5, name: '核磁检查', picUrl: [] },
          { picType: 6, name: '乳管镜检查', picUrl: [] },
          { picType: 7, name: '其他检查', picUrl: [] },
          { picType: 8, name: '病理检查', picUrl: [] },
          // 宫颈
          // { picType: 15, name: '医生建议', picUrl: [] },
          { picType: 9, name: '临床检查', picUrl: [] },
          { picType: 10, name: 'HPV检测', picUrl: [] },
          { picType: 11, name: '细胞学检查', picUrl: [] },
          { picType: 12, name: 'VIA/VILI检查', picUrl: [] },
          { picType: 13, name: '阴道镜检查', picUrl: [] },
          { picType: 14, name: '病理检查', picUrl: [] }
        ]

        reportList.map(x => {
          // 乳腺医生建议
          if (d.nextStep && x.picType === 0) {
            x.l = d.nextStep
          }

          // 宫颈医生建议
          if (d.nextCervixStep && x.picType === 15) {
            x.l = d.nextCervixStep
          }

          // 是否有触诊
          if (x.picType === 1 && d.breastRes && d.breastRes !== '无需检查') {
            // breastRes  无需检查
            x.l = '总体结论：' + d.breastRes
          }
          // 是否有超声
          if (d.resultPic && x.picType === 2 && d.bi_rads !== '无需检查') {
            const f = JSON.parse(d.resultPic)
            x.l = '左侧乳腺：BI-RADS分类' + JSON.parse(f.leftdata).BI_RADS
            x.r = '右侧乳腺：BI-RADS分类' + JSON.parse(f.rightdata).BI_RADS
          }

          // 是否有钼靶 xrayChecks
          if (d.xrayChecks.length > 0 && x.picType === 4 && d.xrayRes !== '待查') {
            const f = JSON.parse(d.xrayChecks[0].xRay)
            x.l = '左侧乳腺：BI-RADS分类' + f.x_ray_detail.editBI_RADS
            x.r = '右侧乳腺：BI-RADS分类' + f.x_ray_detail.editBI_RADS_r
          }

          // 是否有核磁 mr
          if (d.mr && x.picType === 5 && d.mrRes !== '待查') {
            const f = JSON.parse(d.mr)
            x.l = '左侧乳腺：BI-RADS分类' + f.mr_detail.editBI_RADS
            x.r = '右侧乳腺：BI-RADS分类' + f.mr_detail.editBI_RADS_r
          }

          // 是否有乳管镜 bTubeMirror
          if (d.bTubeMirror && x.picType === 6 && d.bTubeMirrorRes !== '待查') {
            const f = JSON.parse(d.bTubeMirror)
            x.l = '左侧乳腺：' + f.mirror_detail.ckresult
            x.r = '右侧乳腺：' + f.mirror_detail.ckresult_r
          }

          // 是否其他 otherExam
          if (d.otherExam && x.picType === 7 && d.otherExamRes !== '待查') {
            const f = JSON.parse(d.otherExam)
            x.l = '左侧乳腺：' + f.other_detail.ckresult
            x.r = '右侧乳腺：' + f.other_detail.ckresult_r
          }

          // 是否有 乳腺病理  pathological
          if (d.pathological && x.picType === 8 && d.pathologicalRes !== '待查') {
            const f = JSON.parse(d.pathological)
            x.l = '左侧乳腺：' + f.pathology_detail.blresult
            x.r = '右侧乳腺：' + f.pathology_detail.blresult_r
          }

          // 是否有妇科 cervixRes
          if (x.picType === 9 && d.cervixRes !== '无需检查' && d.cervix) {
            // cervixRes  无需检查
            const f = JSON.parse(d.cervix)
            let u = '('
            if (f.zhenduanmore.length) {
              f.zhenduanmore.map(item => {
                u += (item === '其他' ? f.zhenduan_other : item) + ','
              })
            }
            u = u.endsWith(',') ? u.replace(/(.*),/, '$1)') : ''
            // zhenduanmore
            x.l = '检查结论：' + d.cervixRes + u
          }

          // 是否有HPV  hpvRes
          if (d.hpvRes && x.picType === 10 && d.hpvRes !== '待查') {
            x.l = '检查结论：' + `${d.hpvRes}`
          }

          // 是否有细胞学 cytology
          if (d.cytologyRes && x.picType === 11 && d.cytologyRes !== '待查') {
            const f = JSON.parse(d.cytology).cytologyRes
            x.l = 'TBS分类诊断：' + `${d.cytologyRes + (f ? `(${f})` : '')}`
          }

          // 是否有VIA  viaVili
          if (d.viaVili && x.picType === 12 && d.viaViliRes !== '待查') {
            const f = JSON.parse(d.viaVili)
            x.l = `VIA检查结论：${f.cusuanranse}`
            x.r = `VILI检查结论：${f.dianranse}`
            if (f.cusuanranse_more1 === 'A-异常') {
              x.l += '（第1象限异常，'
            } else if (f.cusuanranse_more1 === 'C-癌症') {
              x.l += '（第1象限癌症，'
            }
            if (f.cusuanranse_more2 === 'A-异常') {
              x.l += x.l.endsWith('，') ? '第2象限异常，' : '（第2象限异常，'
            } else if (f.cusuanranse_more2 === 'C-癌症') {
              x.l += x.l.endsWith('，') ? '第2象限癌症，' : '（第2象限癌症，'
            }
            if (f.cusuanranse_more3 === 'A-异常') {
              x.l += x.l.endsWith('，') ? '第3象限异常，' : '（第3象限异常，'
            } else if (f.cusuanranse_more3 === 'C-癌症') {
              x.l += x.l.endsWith('，') ? '第3象限癌症，' : '（第3象限癌症，'
            }
            if (f.cusuanranse_more4 === 'A-异常') {
              x.l += x.l.endsWith('，') ? '第4象限异常，' : '（第4象限异常，'
            } else if (f.cusuanranse_more4 === 'C-癌症') {
              x.l += x.l.endsWith('，') ? '第4象限癌症，' : '（第4象限癌症，'
            }
            if (x.l.endsWith('s')) {
              x.l = x.l.substring(0, x.l.length - 1) + ')'
            }

            if (f.dianranse_more1 === 'A-异常') {
              x.r += '（第1象限异常，'
            } else if (f.dianranse_more1 === 'C-癌症') {
              x.r += '（第1象限癌症，'
            }
            if (f.dianranse_more2 === 'A-异常') {
              x.r += x.r.endsWith('，') ? '第2象限异常，' : '（第2象限异常，'
            } else if (f.dianranse_more2 === 'C-癌症') {
              x.r += x.r.endsWith('，') ? '第2象限癌症，' : '（第2象限癌症，'
            }
            if (f.dianranse_more3 === 'A-异常') {
              x.r += x.r.endsWith('，') ? '第3象限异常，' : '（第3象限异常，'
            } else if (f.dianranse_more3 === 'C-癌症') {
              x.r += x.r.endsWith('，') ? '第3象限癌症，' : '（第3象限癌症，'
            }
            if (f.dianranse_more4 === 'A-异常') {
              x.r += x.r.endsWith('，') ? '第4象限异常，' : '（第4象限异常，'
            } else if (f.dianranse_more4 === 'C-癌症') {
              x.r += x.r.endsWith('，') ? '第4象限癌症，' : '（第4象限癌症，'
            }
            if (x.r.endsWith('，')) {
              x.r = x.r.substring(0, x.r.length - 1) + ')'
            }
          }

          // 是否有阴道镜 colposcopeRes
          if (d.colposcopeRes && x.picType === 13 && d.colposcopeRes !== '待查') {
            x.l = '初步诊断：' + d.colposcopeRes
            const f = JSON.parse(d.colposcope)
            if (d.colposcopeRes === '其他') x.l += `(${f.chubuzhenduan_other})`
          }

          // 是否有 宫颈病理  pathologicalCervix
          if (d.pathologicalCervix && x.picType === 14 && d.pathologicalCervixRes !== '待查') {
            const pathologicalCervix = JSON.parse(d.pathologicalCervix)
            const originalResult = pathologicalCervix.binglijieguo === '其他'
              ? pathologicalCervix.binglijieguo_other
              : pathologicalCervix.binglijieguo
            const result = formatPathologicalCervixResult(
              pathologicalCervix,
              fertileCheck,
              originalResult
            )
            x.l = '组织病理学结果：' + result
          }

          // 是否有图片
          if (d.pictures.length) {
            d.pictures.map(y => {
              if (x.picType === y.picType) x.picUrl.push({ picUrl: y.picUrl, position: y.position, id: y.id })
            })
          }
        })
        d.reportList = reportList
        this.data = d
        this.show1 = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.van-loading{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .van-tab{
  font-weight: 600;
}
::v-deep .van-tabs__nav--line{
  background-image: linear-gradient(to right, #7FCCFD, #4788FE);
}
.van-collapse-item{
    margin-bottom: 10px;
    &.mb0{
        margin-bottom: 0;
    }
}
.item_txt{
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:20px;
    word-break: break-all;
    letter-spacing: 1px;
    .img-wrap{
      position: relative;
      .img-label{
        position: absolute;
        top: .2rem;
        right: .1rem;
        background: rgba(0,0,0,0.5);
        z-index: 2;
        font-size: .26rem;
        color: #fff;
        padding: .1rem .12rem;
        border-radius: 5px;
        display: flex;
        align-items: center;
        .van-icon{
          width: .3rem;
          height: .3rem;
          margin-right: .1rem;
        }
      }
    }
    .van-image{
      width: 100%;
      min-height: 60px;
      margin-top: .1rem;
    }
}
.van-overlay{
  z-index: 100;
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
}
.block {
  width: 5rem;
  height: 2.12rem;
  background:rgba(255,255,255,1);
  box-shadow:0px 3px 9px 0px rgba(0,0,0,0.1);
  border-radius:5px;
  font-size: 0.36rem;
  line-height: 0.5rem;
  p{
    font-weight:400;
    color:rgba(51,51,51,1);
    margin-top: 0.45rem;
    text-align: center;
  }
  .footer{
    display: flex;
    justify-content: center;
    margin-top: 15px;
    span{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.2rem;
      height: 0.6rem;
      border-radius: 0.3rem;
    }
    .cancel{
      color: #333;
      background:rgba(255,255,255,1);
      box-shadow:0px 3px 8px 0px rgba(184,184,184,0.4);
      margin-right: 25px;
    }
    .confirm{
      color: #fff;
      background:rgba(78,124,254,1);
      box-shadow:0px 3px 8px 0px rgba(78,124,254,0.4);
    }
  }
}
.tj_doctor_list{
    background: #fff;
    padding-top: 24px;
    padding-bottom: 11px;
    display: flex;
    margin-bottom: 10px;
    overflow-x: scroll;
    border-top: 1px solid #f5f5f5;
    .tj_doctor_item{
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        padding: 0 28px;
        width: 100px;
        &::after{
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            content: '';
            width: 1px;
            height: 162px;
            background: #EEEEEE;
        }
        .van-image{
            width: 90px;
            height: 90px;
            border-radius: 45px;
            overflow: hidden;
            margin-bottom: 12px;
        }
        p{
            width: 100%;
            font-size:14px;
            color:#333;
            line-height:14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            text-align: center;
            .name{
                font-weight: 600;
                color: #444;
                margin-right: 6px;
            }
            &.hospital{
                font-size: 12px;
                margin: 6px 0 12px;
            }
        }
        .van-button{
            width:100px;
            height:30px;
            background:rgba(78,124,254,1);
            box-shadow:0px 3px 8px 0px rgba(78,124,254,0.4);
            border-radius:15px;
            font-size:14px;
            font-weight:400;
            color:#fff;
            line-height:20px;
            border: none;
        }
    }
}
::v-deep {
    .van-cell__title,
    .van-cell__value{
        font-size:16px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:23px;
    }
    .van-collapse-item__title .van-cell__right-icon::before{
        color: #000;
        transform: none;
    }
    .van-collapse-item__title--expanded .van-cell__right-icon::before{
    transform: rotate(90deg);
    }
    .van-cell:not(:last-child)::after{
        left: 0;
    }
    .van-icon__image{
      width: 100%;
      height: 100%;
    }
}
</style>
